import React from 'react'

import { PopUpContainer } from './styles'

interface IProps {
    show: boolean
}

export const GenericPopover: React.FC<IProps> = ({ show, children }) => {
    return <PopUpContainer show={show}>{children}</PopUpContainer>
}
